import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

const Loader = props => {
  if (props.loading) {
    return (
      <Backdrop
        sx={(theme) => ({color: '#fff', zIndex: theme.zIndex.drawer + 1})}
        open={props.loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    )
  } else {
    return props.children
  }
}

export default Loader
